import React from 'react';
import ImpactStatGroup from './ImpactStatGroup';
import Video from '../common/Video';

import styled from 'styled-components';

const StatesWrapper = styled.div`
	img {
		width: 100%;
	}

	@media screen and (min-width: 650px) {
		img {
			max-width: 75%;
			margin: auto;
		}
	}
`;

const StatesGroup = () => {
	return (
		<section id="states-group">
			<StatesWrapper>
				<div className="container container--md">
					<Video
						url="https://res.cloudinary.com/dpabcunnn/video/upload/v1627133451/videos/map-compressed_mkapvk.mp4"
						autoPlay={true}
						hasPlay={false}
					/>
					<ImpactStatGroup
						flex={true}
						number="10"
						unit="states"
						description={`Getting over 2 million items to beneficiaries in need across south-western Nigeria and beyond was a major feat. 
                        
                        By using state liaisons, bus drivers turned distributors, smaller delivery agents - and in some cases, boats! - we sent out PPE to over 570,000 individuals across Ekiti, Lagos, Ondo, Osun, Oyo, Ogun, Edo, Abuja, Kaduna & Kano states.`}
					/>
				</div>
			</StatesWrapper>
		</section>
	);
};

export default StatesGroup;
